import React, {useMemo, useRef, useState} from 'react';
import {Checkbox, DatePicker, Form, Input, InputNumber, Select} from "antd";
import {currencyFormatter, currencyParser} from "../../../../../../assets/scripts/parser-functions";
import {onPasteCurrencyHandler} from "../account-statement/BalancesForm.js";
import dayjs from "dayjs";
const style={width:'100%',maxWidth:250, minWidth:110}
export const askInForm = {
    date: (name, label, disabled, inExtWindow) => {
        const handleBlur = (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false
        };
        if (!inExtWindow) {
            return (
                <Form.Item
                    key={name}
                    label={label}
                    name={name}
                    className="mb-0">
                    <DatePicker
                        
                        disabled={disabled}
                        onBlur={handleBlur}
                        allowClear={true}
                        style={style}
                        format={"D MMM YYYY"}
                    />
                </Form.Item>
            )
        }
        return (
            <Form.Item name={name} label={label} className="mb-0">
                <Input type="date" disabled={disabled}   />
            </Form.Item>
        )
    },
    int: (name, label, disabled, inExtWindow) => {
        return (<Form.Item
                key={name}
                label={label}
                name={name}
                className="mb-0">
                <InputNumber     disabled={disabled} className="w-100" style={style}/>
            </Form.Item>

        )
    },
    text: (name, label, disabled, inExtWindow) => {
        return (<Form.Item
            key={name}
            label={label}
            name={name}
            className="mb-0">
            <Input     disabled={disabled} className="w-100" style={style}/>
        </Form.Item>)
    },
    textarea: (name, label, disabled, inExtWindow) => {
        return (<Form.Item
            key={name}
            label={label}
            name={name}
            className="mb-0">
            <Input.TextArea     disabled={disabled} className="w-100" style={style}/>
        </Form.Item>)
    },
    currency: (name, label, disabled, inExtWindow) => {

        return (<Form.Item
            key={name}
            label={label}
            name={name}
            className="mb-0">
            {inExtWindow ? <Input type="number" disabled={disabled} onPaste={onPasteCurrencyHandler} style={{width: 110}}/> : <InputNumber
                disabled={disabled}
                style={style}
                className="w-100"
                parser={currencyParser}
                formatter={currencyFormatter}
            />}
        </Form.Item>)
    },
    select: (name, label, options, disabled, inExtWindow) => {
        return (<Form.Item
            key={name}
            label={label}
            name={name}
            className="mb-0">
            {inExtWindow ? <select style={style}>
                {options.map((option, index) => {
                    return (<option key={`${name}-${index}`} value={option.value} disabled={disabled}>
                        {option.label}
                    </option>)
                })}

            </select> : <Select     options={options} disabled={disabled} style={style}/>}
        </Form.Item>)
    },
    check: (name, label, disabled) => {
        return (<Form.Item
            key={name}
            label={label}
            name={name}
            className="mb-0" valuePropName="checked">
            <Checkbox disabled={disabled}/>
        </Form.Item>)
    }
}
function DataPointForm({templateItem, clientValue, showLabel = true, setValue, inExtWindow = false, setMortgage}) {

    let [saving, setSaving] = useState(false)
    const [form] = Form.useForm()
    const valueChangeTimer = useRef(null)
    if (!askInForm.hasOwnProperty(templateItem.type)) {
            throw new Error('DataPointForm does not support type ' + templateItem.type)
        }
    let Label = showLabel ? templateItem.label : null

    const handleValuesChange = (changedValues, allValues) => {

        clearTimeout(valueChangeTimer.current)
        // for use with datepicker, cos i cant get onBlur to work with it
        if ((templateItem.type === 'check') && inExtWindow) {



            valueChangeTimer.current = setTimeout(async () => {
                saveValue({target:{value:allValues[templateItem.name]}})
            }, 150)
        }
    }

    const saveValue = async (e) => {
        const value = e.target ? e.target.value : e

        setSaving(true)
        const row = await setValue(value)
        if (row){
            setMortgage(s=>{
                return {
                    ...s,
                    uploads: s.uploads.map((upload) => {
                        if (!row?.uploadID){

                            throw new Error('DataPointForm: row.uploadID is not defined')
                        }
                        if (upload.id !== row?.uploadID) return upload;

                        const existingPoint = (upload?.verifiedData?.items||[]).find(dp => dp.id === row.id);
                        let newItems;

                        if (existingPoint) {
                            newItems = upload?.verifiedData.items.map(dp =>
                                dp.id === row.id ? row : dp
                            );
                        } else {
                            newItems = [...(upload?.verifiedData?.items||[]), row];
                        }

                        return {
                            ...upload,
                            verifiedData: {
                                ...upload.verifiedData,
                                items: newItems
                            }
                        };
                    })
                };
            })
        }

        setSaving(false)
    }

    let initialValues = {[templateItem.name]: inExtWindow && dayjs.isDayjs(clientValue) ? clientValue.format("YYYY-MM-DD") : clientValue}
    const Question = useMemo(() => {
        return templateItem.type === 'select' ?
            askInForm.select(templateItem.name, Label, templateItem.options, saving, inExtWindow) :
            askInForm[templateItem.type](templateItem.name, Label, saving, inExtWindow)
    }, [templateItem, Label, saving, inExtWindow])
    return(

        <Form labelAlign="left" labelCol={{span: 10}} form={form} initialValues={initialValues} onBlur={saveValue} onValuesChange={handleValuesChange}>
            <div className="d-row gap-3 a-center">


                <div className="grow">
                    {Question}
                </div>
            </div>
        </Form>
    )
}
export function UploadDataPoint({upload, name, showLabel = true, inExtWindow=false, setMortgage}) {
    let point = upload.getDataPointByName(name)

    const props = point.formProps(true)

    props.inExtWindow = inExtWindow
    props.showLabel = showLabel

    return (
        <DataPointForm key={upload.id + name} {...props} setMortgage={setMortgage}/>
    );
}
export default DataPointForm;